var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-layout",
    { attrs: { column: "" } },
    [
      _c(
        "v-flex",
        { style: "max-height: " + _vm.height + "px; overflow-y: auto;" },
        [
          _c("v-data-table", {
            staticClass: "elevation-1",
            attrs: {
              headers: _vm.tableData.headers,
              items: _vm.tableData.items,
              pagination: _vm.pagination
            },
            on: {
              "update:pagination": function($event) {
                _vm.pagination = $event
              }
            },
            scopedSlots: _vm._u([
              {
                key: "headers",
                fn: function(props) {
                  return [
                    _c(
                      "tr",
                      [
                        _c("th", { staticClass: "dlBtn-holder" }, [
                          _c("div", {
                            attrs: { id: "downloadButton" },
                            on: {
                              click: function($event) {
                                return _vm.downloadData(_vm.tableData)
                              }
                            }
                          })
                        ]),
                        _vm._v(" "),
                        _vm._l(props.headers, function(header) {
                          return _c(
                            "th",
                            {
                              key: header.text,
                              class: [
                                header.sortable ? "column sortable" : "",
                                _vm.pagination.descending ? "desc" : "asc",
                                header.value === _vm.pagination.sortBy
                                  ? "active"
                                  : ""
                              ],
                              on: {
                                click: function($event) {
                                  return _vm.changeSort(header.value)
                                }
                              }
                            },
                            [
                              _c("v-layout", { attrs: { row: "" } }, [
                                _c("div", [_vm._v(_vm._s(header.text))]),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  {
                                    directives: [
                                      {
                                        name: "show",
                                        rawName: "v-show",
                                        value: header.sortable !== false,
                                        expression: "header.sortable !== false"
                                      }
                                    ]
                                  },
                                  [
                                    _c("v-icon", { attrs: { small: "" } }, [
                                      _vm._v("arrow_upward")
                                    ])
                                  ],
                                  1
                                )
                              ])
                            ],
                            1
                          )
                        })
                      ],
                      2
                    )
                  ]
                }
              },
              {
                key: "items",
                fn: function(props) {
                  return [
                    _c(
                      "tr",
                      [
                        _c("td"),
                        _vm._v(" "),
                        _vm._l(_vm.tableData.headers, function(header) {
                          return _c(
                            "td",
                            {
                              key: header.value,
                              class: [],
                              on: {
                                click: function($event) {
                                  _vm.clickItem(props.item)
                                }
                              }
                            },
                            [
                              _vm._v(
                                "\n            " +
                                  _vm._s(
                                    _vm._f("formatNumberValues")(
                                      props.item[header.value],
                                      header.value
                                    )
                                  ) +
                                  "\n          "
                              )
                            ]
                          )
                        }),
                        _vm._v(" "),
                        _c("td")
                      ],
                      2
                    )
                  ]
                }
              }
            ])
          })
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-783f90ce", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-783f90ce","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Table.vue
// module id = null
// module chunks = 